export const INVESTMENTS_ENDPOINTS = {
    myInvestments: '/investments/me',
    opportunities: '/investments/offers',
    validateAmount: '/investments/validate-amount',
    investments: '/investments',
    offerDetails: (id) => `/investments/offers/${id}`,
    myInvestmentDetails: (id) => `/investments/me/${id}`,
    portfolio: '/investments/portfolio',
    expectedProfit: (id) => `/investments/${id}/expected-profit`,
};
